module.exports = __webpack_public_path__ + "static/media/pla_atv_tra_ppe.2110db6e.png";